import React, { useState } from 'react';
import { Card, Table, Badge, Spinner, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { TIEULUANTONGQUAN_API } from '../../../../utils/apiUrl';
import { trangThaiTieuLuanTongQuanValue } from '../../../../utils/define';
import { Get } from '../../../../utils/httpProvider';
import moment from 'moment';
import ChamTieuLuanModal from './ChamTieuLuanModal';

const TieuLuanTongQuan = ({ hoSoId }) => {
    const [viewMode, setViewMode] = useState('list');
    const [dataEdit, setDataEdit] = useState(null);
    
    const { isLoading, data: queryData, refetch } = useQuery(
        ['tieuLuanTongQuanData', hoSoId],
        () => Get(`${TIEULUANTONGQUAN_API.GET_BY_HOSO_ID}/${hoSoId}`),
        { 
            enabled: !!hoSoId && viewMode === 'list',
            keepPreviousData: true
        }
    );

    // Xử lý data từ API
    let dataList = [];
    if (queryData) {
        if (Array.isArray(queryData)) {
            dataList = queryData;
        } else if (queryData.data && Array.isArray(queryData.data)) {
            dataList = queryData.data;
        } else {
            dataList = [queryData];
        }
    }

    const renderTrangThai = (val) => {
        switch (val) {
            case trangThaiTieuLuanTongQuanValue.chuaThucHien: return <Badge variant="warning">Chưa thực hiện</Badge>;
            case trangThaiTieuLuanTongQuanValue.dangThucHien: return <Badge variant="info">Đang thực hiện</Badge>;
            case trangThaiTieuLuanTongQuanValue.hoanThanh: return <Badge variant="success">Hoàn thành</Badge>;
            default: return <Badge variant="secondary">Chưa xác định</Badge>;
        }
    };

    const renderTooltip = (props, text) => (
        <Tooltip id="button-tooltip" {...props}>
            {text}
        </Tooltip>
    );


    return (
        <>
        <Card className="h-100">
            <Card.Header>
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="font-weight-bold text-primary m-0">Tiểu luận tổng quan</h5>
                </div>
            </Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div className="text-center p-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <>
                        <div className="table-responsive">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th className="text-center" width="50">STT</th>
                                        <th>Tên tiểu luận</th>
                                        <th className="text-center">Từ ngày</th>
                                        <th className="text-center">Đến ngày</th>
                                        <th className="text-center">Trạng thái</th>
                                        <th className="text-center" width="100" style={{ whiteSpace: 'nowrap' }}>Thao tác</th>
                                    </tr>
                                </thead>
                            <tbody>
                                {dataList.length > 0 ? (
                                    dataList.map((item, index) => (
                                        <tr key={item.id}>
                                            <td className="text-center">{index + 1}</td>
                                            <td>{item.tenTieuLuan}</td>
                                            <td className="text-center">
                                                {item.tuNgay ? moment(item.tuNgay).format('DD/MM/YYYY') : ''}
                                            </td>
                                            <td className="text-center">
                                                {item.denNgay ? moment(item.denNgay).format('DD/MM/YYYY') : ''}
                                            </td>
                                            <td className="text-center">{renderTrangThai(item.trangThai)}</td>
                                            <td className="text-center">
                                                <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Kết quả chấm tiểu luận')}>
                                                    <Button variant="info" size="sm" onClick={() => { setDataEdit(item); setViewMode('chamTieuLuan'); }} className="text-white">
                                                        <i className="fas fa-check-double"></i>
                                                    </Button>
                                                </OverlayTrigger>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center text-muted">
                                            Chưa có dữ liệu Tiểu luận tổng quan (chỉ hiển thị khi Phòng HLĐT tạo tiểu luận)
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                        </div>
                    </>
                )}
            </Card.Body>
        </Card>

        {viewMode === 'chamTieuLuan' && dataEdit && (
            <ChamTieuLuanModal
                dataEdit={dataEdit}
                setViewMode={setViewMode}
                isView={true}
                isUserView={true}
            />
        )}
        </>
    );
};

export default TieuLuanTongQuan;
